export default import.meta.glob('./**/*.js', { eager: true });
